module.exports = __webpack_public_path__ + "img/explain_4.3e0066dc.png";